interface TrialLinkTrackerOptions {
    selectors: string[];
  }
  
  export default defineNuxtPlugin((nuxtApp) => {
    const options: TrialLinkTrackerOptions = {
      selectors: [
        'a[class*="btn"]',
      ]
    };
  
    if (import.meta.client) {
      let updateTimeout: NodeJS.Timeout;
      let observer: MutationObserver;
      
      nuxtApp.hook('app:mounted', () => {
        // Debounced update function
        const debouncedUpdate = () => {
          clearTimeout(updateTimeout);
          updateTimeout = setTimeout(() => updateTrialLinks(options.selectors), 200);
        };

        // More targeted observer - only watch for added nodes
        observer = new MutationObserver((mutations) => {
          let shouldUpdate = false;
          for (const mutation of mutations) {
            if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
              // Check if any added nodes contain buttons
              for (const node of mutation.addedNodes) {
                if (node.nodeType === Node.ELEMENT_NODE) {
                  const element = node as Element;
                  if (element.querySelector && element.querySelector('a[class*="btn"]')) {
                    shouldUpdate = true;
                    break;
                  }
                }
              }
            }
            if (shouldUpdate) break;
          }
          if (shouldUpdate) debouncedUpdate();
        });
        
        observer.observe(document.body, { 
          childList: true, 
          subtree: true 
        });
        
        // Initial update with delay to avoid blocking
        if ('requestIdleCallback' in window) {
          requestIdleCallback(() => updateTrialLinks(options.selectors), { timeout: 1000 });
        } else {
          updateTimeout = setTimeout(() => updateTrialLinks(options.selectors), 100);
        }
      });
      
      // Cleanup on unmount
      nuxtApp.hook('app:beforeMount', () => {
        // Cleanup any existing instances
        clearTimeout(updateTimeout);
        if (observer) {
          observer.disconnect();
        }
      });
    }
  });
  
  function updateTrialLinks(selectors: string[]) {
    // Guard against server-side execution
    if (typeof window === 'undefined') return;
    
    const currentUrl = new URL(window.location.href);
  
    selectors.forEach(selector => {
      const links = document.querySelectorAll<HTMLAnchorElement>(selector);
      links.forEach((link) => {
        const linkUrl = new URL(link.href, window.location.origin);
        
        // Preserve existing parameters on the link
        const existingParams = new URLSearchParams(linkUrl.search);
        
        // Add current page parameters, including UTMs
        currentUrl.searchParams.forEach((value, key) => {
          if (!existingParams.has(key)) {
            existingParams.append(key, value);
          }
        });
  
        // Update the link's href
        linkUrl.search = existingParams.toString();
        link.href = linkUrl.toString();
  
      });
    });
  }